import React from "react";
import { View, Text, TextInput, StyleSheet } from "react-native";
import Button from "../Button";
import { scale, verticalScale } from "../../utils/scale";
import color from "../../constants/color";
export class BottomStrip extends React.Component {
  render() {
    return (
      <View style={[styles.beLikeRow, styles.addAddressStrip]}>
        <View>
          <Text style={{ color: "#fff" }}>{this.props.title}</Text>
        </View>
        <Button
          btnText="ऐड कस्टमर"
          buttonWidth={120}
          height={30}
          onPress={this.props.onPress}
        />
      </View>
    );
  }
}
const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  homeContainer: {
    paddingBottom: 60,
    backgroundColor: "#F7F7F7",
  },
  addAddressStrip: {
    position: "absolute",
    backgroundColor: "#333333",
    paddingHorizontal: 15,
    paddingVertical: verticalScale(10),
    width: "100%",
    justifyContent: "space-between",
    bottom: scale(0),
  },
});
